const intialState = {
  assetTypes: {} as any,
  loading: false,
  error: null
};

const assetTypeReducer = (state = intialState, action: any) => {
  switch (action.type) {
    case 'GET_ASSET_TYPES_REQUEST':
      return {
        ...state,
        loading: true
      };
    case 'GET_ASSET_TYPES_SUCCESS':
      return {
        ...state,
        loading: false,
        assetTypes: action.payload.data
      };
    case 'GET_ASSET_TYPES_FAILURE':
      return {
        ...state,
        loading: false,
        error: action.payload.message
      };
    default:
      return state;
  }
};

export default assetTypeReducer;
